import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentPropsWithoutRef } from "react";

import { cn } from "@/lib/cn";

const badge = cva(
  "inline-flex items-center justify-center font-semibold text-white tabular-nums",
  {
    variants: {
      tone: {
        /** 안 읽음 — 봐야 하는 것 */
        alert: "bg-badge",
        /** 조용한 방의 안 읽음 — 굳이 안 봐도 되는 것 */
        muted: "bg-badge-mute",
        /** 다크 레일 위의 조용한 방 개수 */
        onDark: "bg-paper/16 text-paper/60",
      },
      size: {
        sm: "h-[17px] min-w-[17px] rounded-[9px] px-[5px] text-[10px]",
        md: "h-5 min-w-5 rounded-[10px] px-1.5 text-xs",
      },
    },
    defaultVariants: { tone: "alert", size: "md" },
  },
);

type BadgeProps = VariantProps<typeof badge> & {
  count: number;
  /** 이 수를 넘으면 "99+"로 줄인다. 0이면 렌더하지 않는다. */
  max?: number;
} & Omit<ComponentPropsWithoutRef<"span">, "children">;

export function Badge({
  count,
  max = 999,
  tone,
  size,
  className,
  ...rest
}: BadgeProps) {
  if (count <= 0) return null;

  return (
    <span
      className={cn(badge({ tone, size }), className)}
      aria-label={`읽지 않음 ${count}개`}
      {...rest}
    >
      {count > max ? `${max}+` : count}
    </span>
  );
}
